export type UserTypeForStatementStatus = 'adminMaster' | 'adminOutsourcer' | 'company';

export type EmbedMapType = keyof typeof EmbedMapTypeText;

export const EmbedMapTypeText = {
  free_map: '無料マップ',
  cloud: 'イクラウド',
};

export type StatementStatusKeysAllPattern =
  | 'unconfirmed'
  | 'confirming'
  | 'confirmed'
  | 'modifying'
  | 'input_complete'
  | 'conflicted'
  | 'rejected';

export const AdminMasterStatementsStatus = {
  unconfirmed: '未割り当て',
  confirming: '入力中',
  confirmed: '完了',
  modifying: '修正報告済',
  conflicted: '入力エラーあり',
  input_complete: '入力完了',
  rejected: '差し戻し',
};

export const AdminOutsourcerStatementsStatus = {
  unconfirmed: '未入力',
  confirming: '入力中',
  input_complete: '入力完了',
};

export const CompanyStatementsStatus = {
  unconfirmed: '未入力',
  confirming: '入力中',
  confirmed: '完了',
  modifying: '修正報告済',
  rejected: '差し戻し',
};

export const DealType = {
  mediation: '仲介',
  purchase: '買取',
};

export const PurchaseType = {
  other_company: '買取会社への仲介',
  in_house: '自社買取',
};

export const DealAndPurchaseType = {
  mediation: '仲介',
  other_company: '買取会社への仲介',
  in_house: '自社買取',
};

export const MediateType = {
  selling: '売り手',
  buying: '買い手',
  buying_and_selling: '売買両手',
  lending: '貸し手',
  borrowing: '借り手',
  lending_and_borrowing: '貸借両手',
};

export type MediateTypeKeys = keyof typeof MediateType;

export const JusetsuMediateType = {
  all: '全て',
  ...MediateType,
};

//データ表示用　仲介・買取まとめて表示する
export const DisplayDealType = {
  purchase: '買取',
  selling: '売り仲介',
  buying: '買い仲介',
  buying_and_selling: '売買仲介',
  lending: '貸し仲介',
  borrowing: '借り仲介',
  lending_and_borrowing: '貸借仲介',
};

export const PropertyType = {
  mansion: 'マンション',
  land: '土地',
  used_house: '中古戸建て',
  new_house: '新築戸建て',
};

export const ResidenceCurrentStatus = {
  residence: '居住中',
  rented: '賃貸中',
  vacant: '空室',
};

export const LandCurrentStatus = {
  vacant: '更地',
  with_old_house: '古家あり',
  other_current_statuses: 'その他',
};

export const BuildingStructures = {
  wooden: '木造',
  light_steel: '軽量鉄骨造',
  steel: '(重量)鉄骨造',
  rc: '鉄筋コンクリート',
  src: '鉄骨鉄筋コンクリート',
  cb: 'コンクリートブロック',
};

export const LandRight = {
  ownership: '所有権',
  leasehold: '借地権',
  other_land_rights: 'その他',
};

export const PeriodList = {
  half_a_year: '半年',
  one_year: '１年',
  two_years: '２年',
  three_years: '３年',
  five_years: '５年',
  entire_period: '全期間',
};

export const SaleCaseTableTabList = {
  auto: '自動',
  mansion: 'マンション',
  used_house: '中古戸建',
  land: '土地',
  new_house: '新築戸建',
};

//1のときだけ選択肢に1Rあり
export const FloorPlan = {
  option1: [1, 2, 3, 4, 5, 6, 7, 8, 9],
  option2: ['K', 'DK', 'LDK', 'SLDK'],
  option3: ['R', 'K', 'DK', 'LDK', 'SLDK'],
};

export const DisclosureStatementCompanyBuyerOptions = {
  unconfirmed: '未確認',
  confirming: '不動産会社に確認中',
  all_mediation: 'すべて仲介とする',
  all_purchase: 'すべて買取とする',
  company_selected_deal_type: '不動産会社の選択を採用',
};

export const MonthInputFormat = 'yyyy-MM';
export const DateInputFormat = 'yyyy-MM-dd';
export const MonthOutputFormat = 'yyyy年MM月';
export const DateOutputFormat = 'yyyy年MM月dd日';

export const Prefectures: { [key: number]: string } = {
  1: '北海道',
  2: '青森県',
  3: '岩手県',
  4: '宮城県',
  5: '秋田県',
  6: '山形県',
  7: '福島県',
  8: '茨城県',
  9: '栃木県',
  10: '群馬県',
  11: '埼玉県',
  12: '千葉県',
  13: '東京都',
  14: '神奈川県',
  15: '新潟県',
  16: '富山県',
  17: '石川県',
  18: '福井県',
  19: '山梨県',
  20: '長野県',
  21: '岐阜県',
  22: '静岡県',
  23: '愛知県',
  24: '三重県',
  25: '滋賀県',
  26: '京都府',
  27: '大阪府',
  28: '兵庫県',
  29: '奈良県',
  30: '和歌山県',
  31: '鳥取県',
  32: '島根県',
  33: '岡山県',
  34: '広島県',
  35: '山口県',
  36: '徳島県',
  37: '香川県',
  38: '愛媛県',
  39: '高知県',
  40: '福岡県',
  41: '佐賀県',
  42: '長崎県',
  43: '熊本県',
  44: '大分県',
  45: '宮崎県',
  46: '鹿児島県',
  47: '沖縄県',
};

export const ValidationText = {
  required: '入力して下さい',
  requeuedSelect: '選択して下さい',
  invalidZipCode: '郵便番号のフォーマットが違います',
  invalidEmail: 'メールアドレスを入力して下さい',
  takenEmail: 'このメールアドレスは使用されています',
  mismatchedPassword: 'パスワードが一致しません',
  invalidNumber: '半角数字を入力して下さい',
  invalidFloatNumber: '半角数字を小数点以下4桁以内で入力して下さい',
  invalidFloorPlan: '間取りの入力フォーマットが違います',
};

export const NotificationText = {
  error: 'エラーが発生しました',
  invalidValue: '不正な値が入力されています',
  accessNotApproved: 'アクセスが許可されていません',
  successCreateCompany: '会社を作成しました',
  successReviseRequest: '誤入力を報告しました',
  successEditCompany: '会社を編集しました',
  successDeleteCompany: '会社を削除しました',
  successCreateUser: 'ユーザーを作成しました',
  successEditUser: 'ユーザーを編集しました',
  successDeleteUser: 'ユーザーを削除しました',
  successCreateMap: 'マップを作成しました',
  successEditMap: 'マップを編集しました',
  successDeleteMap: 'マップを削除しました',
  successUpdateJusetsu: '重説の保存に成功しました',
  successFinalizeJusetsu: '重説を最終保存しました',
  successDeletionRequest: '重説削除を依頼しました',
  successRejectRequest: '重説を差し戻しました',
  successDeleteJusetsu: '重説データを削除しました',
  successCancelDeleteRequest: '削除依頼を取り消しました',
  successCancelRejectRequest: '重説の差し戻しを取り消しました',
  successForceMerge: '重説の強制編集に成功しました',
  uploadFailed: 'アップロードに失敗しました',
};

export const MaxLength = (text: number) => {
  return text + '文字以内で入力して下さい';
};
export const MaxCount = (text: number) => {
  return `数値を ${text} 桁以内で入力して下さい`;
};
export const MinLength = (text: number) => {
  return text + '文字以上で入力して下さい';
};

export const editJusetsuValidationLabels = [
  {
    formName: 'contract_date',
    label: '売買契約締結日',
  },
  {
    formName: 'town_code',
    label: '町域',
  },
  {
    formName: 'address',
    label: '町域以下',
  },
  {
    formName: 'seller',
    label: '売主名',
  },
  {
    formName: 'buyer',
    label: '買主名',
  },
  {
    formName: 'borrower',
    label: '借主名',
  },
  {
    formName: 'lender',
    label: '借主名',
  },
  {
    formName: 'price',
    label: '成約価格',
  },
  {
    formName: 'mansion_id',
    label: 'マンション名',
  },
  {
    formName: 'mansion_name',
    label: 'マンション名',
  },
  {
    formName: 'floor',
    label: '階数',
  },
  {
    formName: 'occupied_area',
    label: '専有面積',
  },
  {
    formName: 'town_code',
    label: '町域',
  },
  {
    formName: 'address',
    label: '町域以下',
  },
  {
    formName: 'land_area',
    label: '土地面積',
  },
  {
    formName: 'building_area',
    label: '建物面積',
  },
  {
    formName: 'built_date',
    label: '建築年月',
  },
  {
    formName: 'mediation_contract_date',
    label: '媒介契約締結日',
  },
  {
    formName: 'room_number',
    label: '部屋番号',
  },
  {
    formName: 'floor_plan',
    label: '間取',
  },
  {
    formName: 'current_status',
    label: '現況・状態',
  },
  {
    formName: 'architectural_condition',
    label: '建築条件',
  },
  {
    formName: 'building_area',
    label: '建物面積',
  },
  {
    formName: 'built_date',
    label: '建築年月',
  },
  {
    formName: 'building_structure',
    label: '構造',
  },
  {
    formName: 'home_inspection',
    label: '住宅診断',
  },
  {
    formName: 'land_right',
    label: '土地権利',
  },
];

export const editJusetsuProperties = [
  {
    formName: 'seller',
    stateName: 'sellerName',
    setStateName: 'setSellerName',
    initialValue: '',
  },
  {
    formName: 'buyer',
    stateName: 'buyerName',
    setStateName: 'setBuyerName',
    initialValue: '',
  },
  {
    formName: 'lender',
    stateName: 'lenderName',
    setStateName: 'setLenderName',
    initialValue: '',
  },
  {
    formName: 'borrower',
    stateName: 'borrowerName',
    setStateName: 'setBorrowerName',
    initialValue: '',
  },
  {
    formName: 'address',
    stateName: 'address',
    setStateName: 'setAddress',
    initialValue: '',
  },
  {
    formName: 'price',
    stateName: 'price',
    setStateName: 'setPrice',
    initialValue: '',
  },
  {
    formName: 'floor',
    stateName: 'floor',
    setStateName: 'setFloor',
    initialValue: '',
  },
  {
    formName: 'occupied_area',
    stateName: 'occupiedArea',
    setStateName: 'setOccupiedArea',
    initialValue: '',
  },
  {
    formName: 'building_area',
    stateName: 'buildingArea',
    setStateName: 'setBuildingArea',
    initialValue: '',
  },
  {
    formName: 'room_number',
    stateName: 'roomNumber',
    setStateName: 'setRoomNumber',
    initialValue: '',
  },
  {
    formName: 'floor_plan',
    stateName: 'floorPlan',
    setStateName: 'setFloorPlan',
    initialValue: '',
  },
  {
    formName: 'building_structure',
    stateName: 'buildingStructure',
    setStateName: 'setBuildingStructure',
    initialValue: '',
  },
  {
    formName: 'land_right',
    stateName: 'landRight',
    setStateName: 'setLandRight',
    initialValue: null,
  },
  {
    formName: 'home_inspection',
    stateName: 'homeInspection',
    setStateName: 'setHomeInspection',
    initialValue: false,
  },
  {
    formName: 'architectural_condition',
    stateName: 'architecturalCondition',
    setStateName: 'setArchitecturalCondition',
    initialValue: false,
  },
  {
    formName: 'land_category',
    stateName: 'landCategory',
    setStateName: 'setLandCategory',
    initialValue: 'residential',
  },
  {
    formName: 'is_public',
    stateName: 'isPublic',
    setStateName: 'setIsPublic',
    initialValue: null,
  },
];
